import React from "react";
import { Link } from "react-router-dom";

interface ResultsHeaderProps {
    origin: string;
    destination: string;
    departureDate: string;
    returnDate?: string;
    passengers: number;
    onModify: () => void;
}

const ResultsHeader: React.FC<ResultsHeaderProps> = ({
    origin,
    destination,
    departureDate,
    returnDate,
    passengers,
    onModify,
}) => {
    // Format date for display
    const formatDate = (dateStr: string) => {
        const date = new Date(dateStr);
        const options: Intl.DateTimeFormatOptions = {
            weekday: "short",
            day: "numeric",
            month: "short",
            year: "numeric",
        };
        return date.toLocaleDateString("en-US", options);
    };

    return (
        <div className="bg-[#0047ba] w-full" style={{ height: "236px" }}>
            {/* Top navigation bar */}
            <div className="w-full">
                <div className="max-w-[1200px] mx-auto">
                    <div
                        className="flex items-center justify-between py-3"
                        style={{ height: "50px" }}
                    >
                        {/* Logo */}
                        <Link to="/philippine-airlines">
                            <img
                                src="/PR_results.svg"
                                alt="Philippine Airlines"
                                className="h-11 w-auto"
                            />
                        </Link>

                        {/* Language selector */}
                        <button className="text-white text-xs font-base px-4 py-1.5 border border-white rounded-full hover:bg-white hover:bg-opacity-10 transition-colors">
                            English ⌄
                        </button>
                    </div>
                </div>
            </div>

            {/* Search summary bar */}
            <div className="w-full px-5 pb-4 pt-3">
                <div className="max-w-[1200px] mx-auto">
                    <div className="grid grid-cols-3 gap-4 bg-[#002766] rounded-lg px-4 py-2 text-white">
                        {/* Column 1: Route info */}
                        <div className="flex items-center justify-between">
                            <div>
                                <div className="text-sm font-medium">
                                    {origin}
                                </div>
                                <div className="text-xl font-medium">
                                    {origin.substring(0, 3).toUpperCase()}
                                </div>
                            </div>
                            <span className="text-lg px-4">
                                <svg
                                    width="50"
                                    height="30"
                                    viewBox="0 0 50 30"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M0 15 L 40 15"
                                        stroke="white"
                                        strokeWidth="2"
                                    />
                                    <polygon
                                        points="40 10, 50 15, 40 20"
                                        fill="white"
                                    />{" "}
                                    {/* Arrowhead for the right end */}
                                    <path
                                        d="M50 15 L 10 15"
                                        stroke="white"
                                        strokeWidth="2"
                                    />
                                    <polygon
                                        points="10 10, 0 15, 10 20"
                                        fill="white"
                                    />{" "}
                                    {/* Arrowhead for the left end */}
                                </svg>
                            </span>
                            <div>
                                <div className="text-sm font-medium">
                                    {destination}
                                </div>
                                <div className="text-xl font-medium">
                                    {destination.substring(0, 3).toUpperCase()}
                                </div>
                            </div>
                        </div>

                        {/* Column 2: Dates */}
                        <div className="flex items-center gap-8 justify-center">
                            <div>
                                <div className="text-sm font-medium">
                                    Depart
                                </div>
                                <div className="font-bold text-base">
                                    {formatDate(departureDate)}
                                </div>
                            </div>

                            {returnDate && (
                                <div>
                                    <div className="text-sm font-medium">
                                        Return
                                    </div>
                                    <div className="font-bold text-base">
                                        {formatDate(returnDate)}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Column 3: Passengers and Modify button */}
                        <div className="flex items-center justify-between">
                            <div>
                                <div className="text-sm font-medium">
                                    Passenger
                                </div>
                                <div className="font-medium text-base flex items-center gap-2">
                                    <svg
                                        className="w-4 h-4 fill-white"
                                        viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
                                    </svg>
                                    {passengers}
                                </div>
                            </div>

                            <button
                                onClick={onModify}
                                className="bg-white text-[#011e4f] px-6 py-2 rounded-lg font-bold"
                            >
                                Modify
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResultsHeader;
